import { WSContainer } from "@wingspanhq/fe-component-library";
import { useState } from "react";
import { LayoutPaymentsSetup } from "../../shared/components/LayoutPaymentsSetup";
import { Confirmation } from "./components/Confirmation";
import { Form } from "./components/Form";
import { FormData } from "./types";

export const CIP = () => {
  const [preview, setPreview] = useState(true);
  const [submittedValues, setSubmittedValues] = useState<
    FormData | undefined
  >();

  return (
    <LayoutPaymentsSetup wide>
      <WSContainer style={{ maxWidth: 712 }}>
        {preview && submittedValues ? (
          <Confirmation
            data={submittedValues}
            onEdit={() => {
              setPreview(false);
            }}
          />
        ) : (
          <Form
            defaultValues={submittedValues}
            onSubmit={newValues => {
              setSubmittedValues(newValues);
              setPreview(true);
            }}
          />
        )}
      </WSContainer>
    </LayoutPaymentsSetup>
  );
};
